const imports = require("../../../lib");
module.exports = imports.google.api;

const grpc = {};
grpc.web = require("grpc-web");
